import React, { useState, useEffect } from "react";
import { Grid, Backdrop, Box, Typography, Button, Paper, Switch, TextField, IconButton, Radio, RadioGroup, FormControlLabel, FormControl, FormGroup, Checkbox, styled, useTheme } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReactComponent as SmLogo } from "../Common/Logo/smLogo.svg";
import { ReactComponent as Mountains } from "../Auth/Icons/mountains.svg";
import { submitDemographics, getinternalMobilityDemographics, submitDemographicsInternalMobility, reOpenDemographics } from "../../actions/user_actions";
import ReactSelect from "react-select";
import HelpIcon from '@mui/icons-material/Help';
import moment from "moment";
import config from "../../config";

const StyledPaper = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minWidth: 720,
  maxWidth: 720,
  [theme.breakpoints.down(740)]: {
    maxWidth: 600,
    minWidth: 600,
  },
  [theme.breakpoints.down("xs")]: {
    minHeight: "100vh",
    minWidth: 100,
  },
}));

const StyledMountainsGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FDEFE7",
  borderTopRightRadius: 8,
  borderBottomRightRadius: 8,
  overflow: "hidden",
  display: "flex",
}));

const StyledMountains = styled(Mountains)(({ theme }) => ({
  width: "105%",
  marginLeft: -1,
  alignSelf: "flex-end",
  marginBottom: -15,
  [theme.breakpoints.down("xs")]: {
    width: "160%",
    height: "160%",
    marginBottom: -80,
    alignSelf: "flex-start",
  },
}));

const StyledLogo = styled(SmLogo)(({ theme }) => ({
  width: 167,
  height: 40,
  marginBottom: 27,
  marginTop: 20,
}));

function LineManagerSelector(props) {
  const { availableLineManagers = [], newLineManager, classes, onChange, isVerified } = props;
  const [createNew, setCreateNew] = useState(isVerified === "n");
  const [createNewPlaceHolder, setCreateNewPlaceHolder] = useState(isVerified === "n" ? newLineManager : false);

  const options = availableLineManagers.filter((item) => item.userID === newLineManager || !item.softDisabled).map((item) => ({ value: item.userID, label: `${item.name} (${item.email})` }));
  const currentLineManagerObject = newLineManager ? options.find((item) => item.value === newLineManager) : false;

  return (
    <Paper elevation={1} sx={{ paddingInline: "15px", paddingBlock: "5px", mb: 1.25, backgroundColor: "#FDEFE7", width:"100%" }}>
      <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
        <Grid item sx={{ width: "100%" }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography>Manager</Typography>
            </Grid>
            <Grid item>
              <Typography>
                <Checkbox checked={createNew} onChange={() => { onChange(false); setCreateNew(!createNew); }} />
                Create New
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {createNew ? (
          <>
            <Grid item sx={{ width: "100%", display: 'flex', justifyContent: 'center', fontSize: 14, opacity: .7, fontWeight: '500', flexDirection: 'column', textAlign: 'center', alignItems: 'center', whiteSpace: 'nowrap' }}>
              <TextField
                placeholder={createNewPlaceHolder ? createNewPlaceHolder : "Input Line Manager"}
                InputProps={{ sx: { height: 30, fontSize: 12, backgroundColor: "white" } }}
                onChange={(event) => onChange(event.target.value)}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item>
              <Typography sx={{ marginBlock: "5px", fontSize: "12px" }}>
                Newly created Line Managers will be manually invited by HR Managers
              </Typography>
            </Grid>
          </>
        ) : (
          <>
            <Grid item sx={{ width: "100%" }}>
              <ReactSelect
                placeholder={currentLineManagerObject ? currentLineManagerObject.label : "Please Select"}
                value={options.find(function (option) { return option.ID === newLineManager; })}
                onChange={(event) => onChange(event.value)}
                options={options}
              />
            </Grid>
            <Grid item>
              <Typography sx={{ marginBlock: "10px", fontSize: "12px" }}>
                If your current Line Manager does not appear in the selection, click "Create New" to manually enter their name and/or email.
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Paper>
  );
}

function DepartmentSelector(props) {
  const { availableDepartments = [], newDepartment, classes, onChange, isVerified } = props;
  const [createNew, setCreateNew] = useState(isVerified === "n");
  const [createNewPlaceHolder, setCreateNewPlaceHolder] = useState(isVerified === "n" ? newDepartment : false);

  const options = availableDepartments.filter((item) => item.ID === newDepartment || !item.disabled).map((item) => ({ value: item.ID, label: item.departmentName }));
  const currentDepartmentObject = newDepartment ? options.find((item) => item.value === newDepartment) : false;

  return (
    <Paper elevation={1} sx={{ paddingInline: "15px", paddingBlock: "5px", mb: 1.25, backgroundColor: "#FDEFE7" }}>
      <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
        <Grid item sx={{ width: "100%" }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography>Department</Typography>
            </Grid>
            <Grid item>
              <Typography>
                <Checkbox checked={createNew} onChange={() => { onChange(false); setCreateNew(!createNew); }} />
                Create New
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {createNew ? (
          <>
            <Grid item sx={{ width: "100%", display: 'flex', justifyContent: 'center', fontSize: 14, opacity: .7, fontWeight: '500', flexDirection: 'column', textAlign: 'center', alignItems: 'center', whiteSpace: 'nowrap' }}>
              <TextField
                placeholder={createNewPlaceHolder ? createNewPlaceHolder : "Input Department"}
                InputProps={{ sx: { height: 30, fontSize: 12, backgroundColor: "white" } }}
                onChange={(event) => onChange(event.target.value)}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item>
              <Typography sx={{ marginBlock: "5px", fontSize: "12px" }}>
                Newly created departments require verification by HR Managers
              </Typography>
            </Grid>
          </>
        ) : (
          <>
            <Grid item sx={{ width: "100%" }}>
              <ReactSelect
                placeholder={currentDepartmentObject ? currentDepartmentObject.label : "Please Select"}
                value={options.find(function (option) { return option.ID === newDepartment; })}
                onChange={(event) => onChange(event.value)}
                options={options}
              />
            </Grid>
            <Grid item>
              <Typography sx={{ marginBlock: "10px", fontSize: "12px" }}>
                If your department does not appear in the selection, click "Create New" to manually enter the department name
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Paper>
  );
}

function RoleSelector(props) {
  const { availableRoles = [], newRole, classes, onChange } = props;
  const user = useSelector(state => state.user);
  const { organisation = "" } = user;
  const [createNew, setCreateNew] = useState(false);
  const isOrecatapult = organisation === "orecatapult";
  const options = availableRoles.filter((item) => item.ID === newRole || !item.disabled).map((item) => ({ value: item.ID, label: item.roleName }));
  const currentRoleObject = newRole ? options.find((item) => item.value === newRole) : false;

  return (
    <Paper elevation={1} sx={{ paddingInline: "15px", paddingBlock: "5px", mb: 1.25, backgroundColor: "#FDEFE7" }}>
      <Grid container direction="row" justifyContent="flex-start" alignItems="baseline">
        <Grid item sx={{ width: "100%" }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography>Current Role</Typography>
            </Grid>
            <Grid item>
              <Typography>
                <Checkbox 
                  checked={createNew} 
                  onChange={() => { onChange(false); setCreateNew(!createNew); }} 
                  disabled={isOrecatapult}
                />
                Create New
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {createNew ? (
          <>
            <Grid item sx={{ width: "100%", display: 'flex', justifyContent: 'center', fontSize: 14, opacity: .7, fontWeight: '500', flexDirection: 'column', textAlign: 'center', alignItems: 'center', whiteSpace: 'nowrap' }}>
              <TextField
                placeholder="Input Role"
                InputProps={{ sx: { height: 30, fontSize: 12, backgroundColor: "white" } }}
                onChange={(event) => onChange(event.target.value)}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item>
              <Typography sx={{ marginBlock: "5px", fontSize: "12px" }}>
                Newly created roles require verification by HR Managers. Until verified you cannot progress to the next stage. Please ensure your current role isn't already listed
              </Typography>
            </Grid>
          </>
        ) : (
          <>
            <Grid item sx={{ width: "100%" }}>
              <ReactSelect
                placeholder={currentRoleObject ? currentRoleObject.label : "Please Select"}
                value={options.find(function (option) { return option.ID === newRole; })}
                onChange={(event) => onChange(event.value)}
                options={options}
              />
            </Grid>
            <Grid item>
              <Typography sx={{ marginBlock: "5px", fontSize: "12px" }}>
                If your role does not appear in the selection, click "Create New" to manually enter the role title
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Paper>
  );
}

function FreeTextQuestion(props) {
  const { question, classes, onChange } = props;
  return (
    <Grid container direction="row" justifyContent="flex-start" alignItems="baseline" sx={{ m: 0.625 }}>
      <Grid item>
        <Typography>{question.question}</Typography>
      </Grid>
      <Grid item sx={{ width: "100%" }}>
        <TextField
          sx={{ width: "100%", fontSize: 12, backgroundColor: "#F5F6F7", '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
          InputProps={{ sx: { height: 30, fontSize: 12 } }}
          value={question.answer}
          onChange={(event) => onChange(event.target.value)}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );
}

function SingleChoiceQuestion(props) {
  const { question, classes, onChange } = props;
  return (
    <Grid container direction="row" justifyContent="flex-start" alignItems="baseline" sx={{ m: 0.625 }}>
      <Grid item>
        <Typography>{question.question}</Typography>
      </Grid>
      <Grid item>
        <Grid container direction="row" justifyContent="flex-start" alignItems="baseline">
          {question.choices.map((choice) => (
            <Grid item sx={{ m: 0.625 }} key={choice}>
              <Button
                variant="contained"
                sx={{ marginTop: 2, marginBottom: 2, [theme => theme.breakpoints.down("xs")]: { marginTop: 1.25, marginBottom: 1.75 } }}
                color={choice === question.answer ? "primary" : "inherit"}
                fullWidth
                onClick={() => onChange(choice)}
              >
                {choice}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

function MultiChoiceQuestion(props) {
  const { question, classes, onChange } = props;
  return (
    <Grid container direction="row" justifyContent="flex-start" alignItems="baseline" sx={{ m: 0.625 }}>
      <Grid item>
        <Typography>{question.question}</Typography>
      </Grid>
      <Grid item>
        <Grid container direction="row" justifyContent="flex-start" alignItems="baseline">
          {question.choices.map((choice) => (
            <Grid item sx={{ m: 0.625 }} key={choice}>
              <Button
                variant="contained"
                sx={{ marginTop: 2, marginBottom: 2, [theme => theme.breakpoints.down("xs")]: { marginTop: 1.25, marginBottom: 1.75 } }}
                color={question.answer && question.answer.includes(choice) ? "primary" : "inherit"}
                fullWidth
                onClick={() => onChange(choice)}
              >
                {choice}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}


const Demographics = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const user = useSelector(state => state.user);
  const { showDemographics, showDemographicsEdit, showHello, providerDetails, organisation, internalMobilityProvider, internalMobilityQuestions, internalMobilityRoles, internalMobilityDepartments, internalMobilityDepartmentVerified, internalMobilityLineManagers, internalMobilityLineManagerVerified, internalMobilityResponses, holdUser, allow_reverse_mine = true, trainingOpportunities = true, jobOpportunities = true, dateOfBirth, gender, rightTooWork, hasNoticePeriod, candidateStatus, internalMobilityRole, internalMobilityDepartment, internalMobilityLineManager, orgDetails: { name = "" } = {} } = user;
  const [lookingForWork, setLookingForWork] = useState(allow_reverse_mine);
  const [situation, setSituation] = useState(candidateStatus);
  const [newTrainingOpportunities, setNewTrainingOpportunities] = useState(trainingOpportunities || true);
  const [newJobOpportunities, setNewJobOpportunities] = useState(jobOpportunities || true);
  const [newFutureJobs, setNewFutureJobs] = useState(jobOpportunities);
  const [newDateOfBirth, setNewDateOfBirth] = useState(dateOfBirth ? moment.unix(dateOfBirth / 1000).format("YYYY-MM-DD") : null);
  const [newGender, setNewGender] = useState(gender);
  const [newRightTooWork, setNewRightTooWork] = useState(rightTooWork);
  const [newHasNoticePeriod, setNewHasNoticePeriod] = useState(hasNoticePeriod);
  const [showHelp1, setShowHelp1] = useState(false);
  const [showHelp2, setShowHelp2] = useState(false);
  const [updatedInternalMobilityQuestions, setUpdatedInternalMobilityQuestions] = useState(internalMobilityResponses?.questions || undefined);
  const [updateCheck, setUpdateCheck] = useState(false);
  const [selectedRole, setSelectedRole] = useState(internalMobilityRole || "");
  const [selectedDepartment, setSelectedDepartment] = useState(internalMobilityDepartment || "");
  const [selectedLineManager, setSelectedLineManager] = useState(internalMobilityLineManager || "");

  const lookingOptions = [{ value: "Unemployed", label: "Unemployed" }, { value: "Employed but open to new opportunities", label: "Employed but open to new opportunities" }, { value: "Student", label: "Student" }, { value: "Looking to re-enter the labour market", label: "Looking to re-enter the labour market" }];
  const notLookingOptions = [{ value: "Employed and satisfied", label: "Employed and satisfied" }, { value: "Student", label: "Student" }, { value: "Looking after family / home", label: "Looking after family / home" }, { value: "Sick", label: "Sick" }, { value: "Retired", label: "Retired" }, { value: "Other", label: "Other" }];
  const genderOptions = [{ value: "male", label: "Male" }, { value: "female", label: "Female" }, { value: "non binary", label: "Non-binary" }, { value: "transgender", label: "Transgender" }, { value: "prefer not to say", label: "Prefer not to say" }, { value: "other", label: "Other" }];

  const viewPermissions = providerDetails?.viewPermissions || {};

  useEffect(() => {
    if (internalMobilityProvider && !internalMobilityQuestions) {
      dispatch(getinternalMobilityDemographics());
    }
  }, [internalMobilityProvider, internalMobilityQuestions]);

  useEffect(() => {
      async function checkIMQs() {
        if(internalMobilityProvider && internalMobilityQuestions){
          if(!updatedInternalMobilityQuestions){
            setUpdatedInternalMobilityQuestions(internalMobilityQuestions)
          }
          else if(updatedInternalMobilityQuestions && !updateCheck){
            setUpdateCheck(true);
            let newQuestions = []

            internalMobilityQuestions.forEach((question) => {
              if(question && question.id){
                if(!updatedInternalMobilityQuestions.find((item) => item.id && item.id === question.id)){
                  newQuestions.push(question);
                }
              }
            })
            if(newQuestions.length > 0){
              setUpdatedInternalMobilityQuestions([...updatedInternalMobilityQuestions, ...newQuestions]);
              dispatch(reOpenDemographics());
            }
          }
        }
      }
      checkIMQs()
    }, [internalMobilityProvider, internalMobilityQuestions, internalMobilityResponses]);

  const updateIMQs = (index, newValue, isMultiple) => {
    setUpdatedInternalMobilityQuestions(prevState => {
      return prevState.map((_value, _index) => {
        if (index === _index) {
          if (isMultiple) {
            const currentAnswers = _value.answer || [];
            if (currentAnswers.includes(newValue)) {
              _value.answer = currentAnswers.filter((val) => val !== newValue);
            } else {
              _value.answer = [...currentAnswers, newValue];
            }
          } else {
            _value.answer = newValue;
          }
        }
        return _value;
      });
    });
  };

  const submitDisabled = updatedInternalMobilityQuestions ? updatedInternalMobilityQuestions.find((item) => !item.answer || item.answer === "" || item.answer.length === 0) || ["", false].includes(selectedRole) || ["", false].includes(selectedDepartment) || ["", false].includes(selectedLineManager) : false;

  if (holdUser) {
    return (
      <Backdrop
        open={showDemographics}
        transitionDuration={{ appear: 0, exit: 500, enter: 0 }}
        sx={{ zIndex: 8000 }}
      >
        <Box sx={{ flexGrow: 1, zIndex: 12000, position: "absolute", backgroundColor: "#F8F9FA", width: "100%", height: "100%", overflow: 'scroll' }}>
          <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ minHeight: "100vh" }}>
            <Grid item sx={{ display: { xs: 'none', sm: 'flex' } }}>
              {organisation !== "skillzminer" ? (
                <Box component="img" src={`${config.STORAGE_CLOUDFRONT_URL}/logos/${organisation}_appnav_logo.png`} sx={{ maxHeight: 160 }} />
              ) : (
                <StyledLogo />
              )}
            </Grid>
            <Grid item>
              <StyledPaper>
                <Grid container direction="row-reverse" justifyContent="center" alignItems="stretch" sx={{ minHeight: 450 }}>
                  <StyledMountainsGrid item size={{xs:12, sm:5}}>
                    <StyledMountains />
                  </StyledMountainsGrid>
                  <Grid item size={{xs:12, sm:7}}>
                    <Box sx={{ ml: 4, mr: 3.375, mt: 4, mb: 2.5, [theme.breakpoints.down("xs")]: { m: 2 } }}>
                      <Typography variant="h4" sx={{ fontSize: 32, [theme.breakpoints.down("sm")]: { fontSize: 25 } }}>
                        Thank you for submitting your details
                      </Typography>
                      <Typography variant="h6" sx={{ color: "#202A3E", fontSize: 14, mt: 0.375, mb: 2 }}>
                        You will receive an email when your role has been assigned
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </StyledPaper>
              {organisation !== "skillzminer" && (
                <Grid container direction="column" justifyContent="center" alignItems="center">
                  <Grid item sx={{ mb: 0.625, mt: 0 }}>
                    <Typography variant="body2" sx={{ color: "#5A6375", fontSize: 14, mt: 1.75, textAlign: "center" }}>
                      Powered By
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Box component="img" src={`${config.STORAGE_CLOUDFRONT_URL}/logos/${organisation}_powered_by_logo.png`} sx={{ height: 40, width: 165 }} />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Box>
      </Backdrop>
    );
  }
  else if (showDemographics && ((!internalMobilityProvider && !viewPermissions.additionalPersonalInfoCheckbox) || (internalMobilityProvider && ((internalMobilityQuestions && internalMobilityQuestions.length > 0) || internalMobilityDepartments || internalMobilityRoles || internalMobilityLineManagers)))) {
    return (
      <Backdrop
        open={showDemographics}
        transitionDuration={{ appear: 0, exit: 500, enter: 0 }}
        sx={{ zIndex: 8000 }}
      >
        <Box sx={{ flexGrow: 1, zIndex: 12000, position: "absolute", backgroundColor: "#F8F9FA", width: "100%", height: "100%", overflow: 'scroll' }}>
          <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ minHeight: "100vh" }}>
            <Grid item sx={{ display: { xs: 'none', sm: 'flex' } }}>
              {organisation !== "skillzminer" ? (
                <Box component="img" src={`${config.STORAGE_CLOUDFRONT_URL}/logos/${organisation}_appnav_logo.png`} sx={{ maxHeight: 160 }} />
              ) : (
                <StyledLogo />
              )}
            </Grid>
            <Grid item>
              <StyledPaper>
                <Grid container direction="row-reverse" justifyContent="center" alignItems="stretch" sx={{ minHeight: 450 }}>
                  <StyledMountainsGrid item size={{xs:12, sm:5}}>
                    <StyledMountains />
                  </StyledMountainsGrid>
                  <Grid item size={{xs:12, sm:7}}>
                    <Box sx={{ ml: 4, mr: 3.375, mt: 4, mb: 2.5, [theme.breakpoints.down("xs")]: { m: 2 } }}>
                      {internalMobilityProvider ? (
                        <>
                          <Typography variant="h4" sx={{ fontSize: 32, [theme.breakpoints.down("sm")]: { fontSize: 25 } }}>
                            {name + " Employee Questions"}
                          </Typography>
                          <Typography variant="h6" sx={{ color: "#202A3E", fontSize: 14, mt: 0.375, mb: 2 }}>
                            {showDemographicsEdit ? "Please update the following information if your current situation has changed." : "Before we begin, please complete the following form. You are able to update this information later via the settings page."}
                          </Typography>
                        </>
                      ) : (showHello ? (
                        <>
                          <Typography variant="h4" sx={{ fontSize: 32, [theme.breakpoints.down("sm")]: { fontSize: 25 } }}>
                            One more thing
                          </Typography>
                          <Typography variant="h6" sx={{ color: "#202A3E", fontSize: 14, mt: 0.375, mb: 2 }}>
                            Before we begin, please complete the following form. You are able to update this information later via the settings page.
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography variant="h4" sx={{ fontSize: 32, [theme.breakpoints.down("sm")]: { fontSize: 25 } }}>
                            Update information
                          </Typography>
                          <Typography variant="h6" sx={{ color: "#202A3E", fontSize: 14, mt: 0.375, mb: 2 }}>
                            Please update the following information if your current situation has changed.
                          </Typography>
                        </>
                      ))}
                      <Box component="form" sx={{ width: "100%" }}>
                        {internalMobilityProvider ? (
                          <>
                            <Grid container direction="row" justifyContent="center" alignItems="baseline">
                              {!showDemographicsEdit && (
                                <RoleSelector availableRoles={internalMobilityRoles} onChange={(value) => setSelectedRole(value)} newRole={selectedRole} />
                              )}
                              <DepartmentSelector availableDepartments={internalMobilityDepartments} onChange={(value) => setSelectedDepartment(value)} newDepartment={selectedDepartment} isVerified={internalMobilityDepartmentVerified} />
                              <LineManagerSelector availableLineManagers={internalMobilityLineManagers} onChange={(value) => setSelectedLineManager(value)} newLineManager={selectedLineManager} isVerified={internalMobilityLineManagerVerified} />
                              {updatedInternalMobilityQuestions && updatedInternalMobilityQuestions.map((question, index) => {
                                if (question.questionType === "freetext") {
                                  return (<FreeTextQuestion key={index} question={question} onChange={(value) => updateIMQs(index, value)} />);
                                }
                                if (question.questionType === "hasChoices") {
                                  return (<SingleChoiceQuestion key={index} question={question} onChange={(value) => updateIMQs(index, value)} />);
                                }
                                if (question.questionType === "multipleChoices") {
                                  return (<MultiChoiceQuestion key={index} question={question} onChange={(value) => updateIMQs(index, value, true)} />);
                                }
                                return null;
                              })}
                              <Box sx={{ position: "relative", width: "100%" }}>
                                <Button
                                  variant="contained"
                                  sx={{ mt: 2, mb: 2 }}
                                  color="primary"
                                  fullWidth
                                  disabled={submitDisabled}
                                  onClick={async () => await dispatch(submitDemographicsInternalMobility({
                                    questions: updatedInternalMobilityQuestions,
                                    department: selectedDepartment,
                                    role: selectedRole,
                                    lineManager: selectedLineManager
                                  }))}
                                >
                                  Submit
                                </Button>
                              </Box>
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Grid container direction="row" justifyContent="center" alignItems="baseline" spacing={0}>
                              <Grid item size={5}>
                                <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 16, mb: 0.5, mt: 2.25, textAlign: "center"}}>
                                  Not looking for work
                                </Typography>
                              </Grid>
                              <Grid item size={2}>
                                <Switch checked={lookingForWork} onChange={() => setLookingForWork(!lookingForWork)} color="primary" name="checkedB" inputProps={{ 'aria-label': 'primary checkbox' }} />
                              </Grid>
                              <Grid item size={5}>
                                <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 16, mb: 0.5, mt: 2.25, textAlign: "center" }}>
                                  Looking for work
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container direction="row" justifyContent="flex-start" alignItems="baseline">
                              <Grid item>
                                <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 16, mb: 0.5, mt: 2.25 }}>
                                  What is your current situation?
                                </Typography>
                              </Grid>
                              <Grid item>
                                <IconButton id="help" onClick={() => setShowHelp1(!showHelp1)}>
                                  <HelpIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                            <Grid item>
                              {showHelp1 && (
                                <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 14, mt: 0.375, mb: 2, m: 0.625 }}>
                                  These responses are optional but it will help employers and recruiters better understand your situation.
                                </Typography>
                              )}
                            </Grid>
                            <ReactSelect
                              placeholder="Select Situation"
                              value={lookingForWork ? lookingOptions.filter(option => option.label === situation) : notLookingOptions.filter(option => option.label === situation)}
                              onChange={(event) => setSituation(event.label)}
                              options={lookingForWork ? lookingOptions : notLookingOptions}
                            />
                            <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 16, mb: 0.5, mt: 2.25 }}>
                              I'm open to:
                            </Typography>
                            <FormControl component="fieldset" sx={{ m: 1.25, ml: 1.875 }}>
                              <FormGroup>
                                <FormControlLabel control={<Checkbox checked={newTrainingOpportunities} onChange={() => setNewTrainingOpportunities(!newTrainingOpportunities)} name="training" />} label="Training opportunities" />
                                {lookingForWork ? (
                                  <FormControlLabel control={<Checkbox checked={newJobOpportunities} onChange={() => setNewJobOpportunities(!newJobOpportunities)} name="jobs" />} label="All job opportunities" />
                                ) : (
                                  <FormControlLabel control={<Checkbox checked={newFutureJobs} onChange={() => setNewFutureJobs(!newFutureJobs)} name="futureJobs" />} label="Eventually looking for work again" />
                                )}
                              </FormGroup>
                            </FormControl>
                            <Grid container direction="row" justifyContent="flex-start" alignItems="baseline">
                              <Grid item>
                                <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 16, mb: 0.5, mt: 2.25 }}>
                                  Additional information
                                </Typography>
                              </Grid>
                              <Grid item>
                                <IconButton id="help" onClick={() => setShowHelp2(!showHelp2)}>
                                  <HelpIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                            <Grid item>
                              {showHelp2 && (
                                <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 14, mt: 0.375, mb: 2, m: 0.625 }}>
                                  We don’t discriminate based on age and gender so employers and recruiters will never see this information. We collect it so that if a training programme or opportunity arises that is limited by these criteria you will be highlighted. However, these are optional fields so if you don’t feel comfortable inputting this data simply ignore them.
                                </Typography>
                              )}
                            </Grid>
                            <Grid container direction="row" justifyContent="space-between" alignItems="baseline" spacing={2}>
                              <Grid item>
                                <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 14, mt: 0.375, mb: 2 }}>
                                  Date of Birth
                                </Typography>
                              </Grid>
                              <Grid item size={6}>
                                <TextField
                                  id="date"
                                  type="date"
                                  value={newDateOfBirth}
                                  sx={{ marginTop: 0, marginBottom: 0, fontSize: 14 }}
                                  onChange={(event) => setNewDateOfBirth(event.target.value)}
                                />
                              </Grid>
                            </Grid>
                            <Grid container direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mt: 1.875 }} spacing={2}>
                              <Grid item>
                                <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 14, mt: 0.375, mb: 2 }}>
                                  Gender
                                </Typography>
                              </Grid>
                              <Grid item size={6}>
                                <ReactSelect
                                  placeholder="Select Gender"
                                  value={genderOptions.filter(option => option.label === newGender)}
                                  onChange={(event) => setNewGender(event.label)}
                                  options={genderOptions}
                                />
                              </Grid>
                            </Grid>
                            <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 16, mb: 0.5, mt: 2.25 }}>
                              Do you have the right to work in the UK?
                            </Typography>
                            <RadioGroup name="rightTooWork" value={newRightTooWork} onChange={(event) => setNewRightTooWork(event.target.value)} sx={{ ml: 1.875 }}>
                              {["Yes", "No"].map(item => (<FormControlLabel value={item} control={<Radio />} label={item} key={item} />))}
                            </RadioGroup>
                            {situation?.includes("Employed") && (
                              <>
                                <Typography variant="body1" sx={{ color: "#202A3E", fontSize: 16, mb: 0.5, mt: 2.25 }}>
                                  Do you have a notice period?
                                </Typography>
                                <RadioGroup name="hasNoticePeriod" value={newHasNoticePeriod} onChange={(event) => setNewHasNoticePeriod(event.target.value)} sx={{ ml: 1.875 }}>
                                  {["Yes", "No"].map(item => (<FormControlLabel value={item} control={<Radio />} label={item} key={item} />))}
                                </RadioGroup>
                              </>
                            )}
                            <Box sx={{ position: "relative" }}>
                              <Button
                                variant="contained"
                                sx={{ mt: 2, mb: 2 }}
                                color="primary"
                                fullWidth
                                onClick={async () => {
                                  await dispatch(submitDemographics({
                                    lookingForWork: lookingForWork,
                                    situation: situation,
                                    trainingOpportunities: newTrainingOpportunities,
                                    jobOpportunities: lookingForWork ? newJobOpportunities : newFutureJobs,
                                    dateOfBirth: moment(newDateOfBirth).valueOf(),
                                    gender: newGender,
                                    rightTooWork: newRightTooWork,
                                    hasNoticePeriod: newHasNoticePeriod
                                  }));
                                }}
                              >
                                Submit
                              </Button>
                            </Box>
                          </>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </StyledPaper>
              {organisation !== "skillzminer" && (
                <Grid container direction="column" justifyContent="center" alignItems="center">
                  <Grid item sx={{ mb: 0.625, mt: 0 }}>
                    <Typography variant="body2" sx={{ color: "#5A6375", fontSize: 14, mt: 1.75, textAlign: "center" }}>
                      Powered By
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Box component="img" src={`${config.STORAGE_CLOUDFRONT_URL}/logos/${organisation}_powered_by_logo.png`} sx={{ height: 40, width: 165 }} />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Box>
      </Backdrop>
    );
  }
  return null;
};

export default Demographics;